import type { TopArtist } from "./TopArtistsList";

export type FanLevelGroup = {
  level: number;
  levelName: string;
  artists: { artist: TopArtist; rank: number }[];
};

export function groupArtistsByFanLevel(
  artists: readonly TopArtist[],
): FanLevelGroup[] {
  const groups = new Map<number, FanLevelGroup>();

  artists.forEach((artist, index) => {
    const group = groups.get(artist.level) ?? {
      level: artist.level,
      levelName: artist.levelName,
      artists: [],
    };
    group.artists.push({ artist, rank: index + 1 });
    groups.set(artist.level, group);
  });

  return [...groups.values()].sort((a, b) => b.level - a.level);
}
